import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface SectionCardProps {
  title: string;
  description: string;
  icon: string;
  isCompleted: boolean;
  isCurrent: boolean;
  score?: number;
}

const SectionCard = ({ title, description, icon, isCompleted, isCurrent, score }: SectionCardProps) => {
  return (
    <div className={`p-6 rounded-lg border-2 transition-all duration-300 ${
      isCurrent
        ? 'border-primary bg-primary/5 shadow-subtle'
        : isCompleted
        ? 'border-accent/50 bg-accent/5' :'border-border bg-card'
    }`}>
      <div className="flex items-start gap-4">
        <div className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center ${
          isCompleted
            ? 'bg-accent text-white'
            : isCurrent
            ? 'bg-primary text-white' :'bg-muted text-muted-foreground'
        }`}>
          {isCompleted ? (
            <Icon name="CheckIcon" size={24} />
          ) : (
            <Icon name={icon as any} size={24} />
          )}
        </div>
        
        <div className="flex-1">
          <h3 className="text-lg font-display font-semibold text-secondary mb-1">{title}</h3>
          <p className="text-sm text-muted-foreground mb-3">{description}</p>
          
          {isCompleted && score !== undefined && (
            <div className="flex items-center gap-2">
              <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full bg-accent transition-all duration-500"
                  style={{ width: `${score}%` }}
                />
              </div>
              <span className="text-sm font-medium text-accent">{score}%</span>
            </div>
          )}
          
          {isCurrent && (
            <span className="inline-flex items-center gap-1 text-sm font-medium text-primary">
              <Icon name="ArrowRightIcon" size={16} />
              In Progress
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionCard;